import { loginUrl } from '@lessonnine/babbel-urls.js';
import { Locale } from '@lessonnine/babbel-urls.js/dist/types/locale';

import { getValidatedQueryStringFromParams } from 'src/dataLayer/localData/queryParams/index';
import { LOCALE } from 'src/dataLayer/env';
import { trackUserRedirect } from 'src/dataLayer/remoteData/babbelEventStream';
import { HandleExistingEmail } from './types';

export const handleExistingEmail: HandleExistingEmail = (learnLang, callback = (): void => {}) => {
  const validatedQueryParams = getValidatedQueryStringFromParams(window.location.search, learnLang);
  const redirectUrl = `${loginUrl(LOCALE as Locale)}/password${validatedQueryParams}`;
  callback();
  trackUserRedirect({
    learnLang,
    source: window.location.href,
    target: redirectUrl
  });
  window.location.assign(redirectUrl);
};
